import React, { useState } from 'react';
import { View, ScrollView, Pressable } from 'react-native';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';
import WorkTaskBoundaryCard from '@/components/Coworker/WorkTaskBoundaryCard';
import WorkTaskStartedNotice from '@/components/Coworker/WorkTaskStartedNotice';

export default function WorkTaskBoundaryPreview() {
  const { colors } = useTheme();
  const [kind, setKind] = useState('separate');
  const [result, setResult] = useState('');
  if (!__DEV__) return null;
  const review = { requestId: kind, state: 'pending',
    message: kind === 'related' ? 'Make another ad using the same robot character and logo.' : 'Now create a new video about growing a kitchen garden.',
    decision: { action: kind === 'uncertain' ? 'clarify' : 'new_task', reason: kind === 'uncertain' ? 'ambiguous' : 'separate_project', needsReferences: kind !== 'separate' },
    references: [{ id: 'robot', name: 'Robot character — approved reference.png' }, { id: 'logo', name: 'Brand logo.svg' }, { id: 'old-video', name: 'Previous film — final.mp4' }] };
  return <ScrollView style={{ flex: 1, backgroundColor: colors.solid_color_primary }} contentContainerStyle={{ padding: 32, alignItems: 'center' }}>
    <View style={{ maxWidth: 780, width: '100%', gap: 24 }}>
      <Text size="xl" weight="bold">A fresh project, an organized chat</Text>
      <Text color="secondary">Development preview · Fictional project and files · No work is submitted</Text>
      <View style={{ flexDirection: 'row', gap: 22 }}>
        {['separate', 'related', 'uncertain'].map(value => <Pressable key={value} accessibilityRole="button" onPress={() => { setKind(value); setResult(''); }}><Text>{value === 'separate' ? 'Separate project' : value === 'related' ? 'Reuse selected assets' : 'Uncertain request'}</Text></Pressable>)}
      </View>
      <View style={{ padding: 20, borderRadius: 16, backgroundColor: colors.solid_color_secondary }}>
        <Text weight="bold">Robot coffee-break film</Text>
        <Text color="secondary" style={{ marginTop: 8 }}>6 clips · Final video delivered · Your existing work stays here</Text>
      </View>
      {kind === 'separate' ? <>
        <WorkTaskStartedNotice source={{ conversationId: 'fictional', title: 'Robot coffee-break film' }} onOpenSource={() => setResult('Preview: original project link.')} />
        <View style={{ padding: 20, gap: 12 }}>
          <Text weight="bold">Gab AI · 30-second commercial</Text>
          <Text>I want to create a 30 second commercial for gab ai.</Text>
          <Text color="secondary">Your full script and attachments arrive here automatically.</Text>
        </View>
      </> : <WorkTaskBoundaryCard review={review} sourceActive onResolve={async (choice, details) => setResult(choice === 'new_task' ? `Preview: new chat with ${details.referenceFileIds.length} selected reference(s).` : 'Preview: continued the existing project.')} onCancel={async () => setResult('Preview: request cancelled.')} />}
      {!!result && <Text accessibilityRole="alert">{result}</Text>}
    </View>
  </ScrollView>;
}
